import { render, staticRenderFns } from "./headcanvas.vue?vue&type=template&id=07cf16c6&scoped=true&"
import script from "./headcanvas.vue?vue&type=script&lang=js&"
export * from "./headcanvas.vue?vue&type=script&lang=js&"
import style0 from "./headcanvas.vue?vue&type=style&index=0&id=07cf16c6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07cf16c6",
  null
  
)

export default component.exports